//  document.addEventListener('DOMContentLoaded', () => {

//     const faq_item = document.querySelectorAll(".prodDescription_wrap .faq_itemWrap .faq_item");

//     function initFaq() {
//     if (window.innerWidth > 749) {
//         // 👉 Desktop: all open by default + toggle freely
//         faq_item.forEach((item) => {
//         const faq_qus = item.querySelector(".faq_qus");
//         const faq_ans = item.querySelector(".faq_ans");

//         if (faq_qus && faq_ans) {
//             // open by default
//             item.classList.add("open");
//             faq_qus.classList.add("active");
//             faq_ans.style.height = faq_ans.scrollHeight + "px";

//             // toggle freely
//             faq_qus.onclick = function () {
//             const isOpen = item.classList.contains("open");
//             if (isOpen) {
//                 item.classList.remove("open");
//                 faq_qus.classList.remove("active");
//                 faq_ans.style.height = 0;
//             } else {
//                 item.classList.add("open");
//                 faq_qus.classList.add("active");
//                 faq_ans.style.height = faq_ans.scrollHeight + "px";
//             }
//             };
//         }
//         });
//     } else {
//         // 👉 Mobile: all closed by default, accordion style
//         faq_item.forEach((item) => {
//         const faq_qus = item.querySelector(".faq_qus");
//         const faq_ans = item.querySelector(".faq_ans");

//         if (faq_qus && faq_ans) {
//             // reset closed
//             item.classList.remove("open");
//             faq_qus.classList.remove("active");
//             faq_ans.style.height = 0;

//             faq_qus.onclick = function () {
//             const isOpen = item.classList.contains("open");

//             // close all first
//             faq_item.forEach((i) => {
//                 const qus = i.querySelector(".faq_qus");
//                 const ans = i.querySelector(".faq_ans");
//                 if (qus && ans) {
//                 i.classList.remove("open");
//                 qus.classList.remove("active");
//                 ans.style.height = 0;
//                 }
//             });

//             // open clicked one
//             if (!isOpen) {
//                 item.classList.add("open");
//                 faq_qus.classList.add("active");
//                 faq_ans.style.height = faq_ans.scrollHeight + "px";
//             }
//             };
//         }
//         });
//     }
//     }

//     // Run on load
//     initFaq();

//     // Optional: re-run on resize
//     window.addEventListener("resize", () => {
//     initFaq();
//     });

//  });

document.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll('.prodDescription_wrap .faq_itemWrap .faq_item');

  function initFaq() {
    faqItems.forEach(item => {
      const qus = item.querySelector('.faq_qus');
      const ans = item.querySelector('.faq_ans');
      if (!qus || !ans) return;

      qus.onclick = null;

      // if (window.innerWidth > 749) {
      //   item.classList.add('open');
      //   qus.classList.add('active');
      //   ans.style.height = ans.scrollHeight + 'px';
      // } else {
      //   item.classList.remove('open');
      //   qus.classList.remove('active');
      //   ans.style.height = 0;
      // }
      
      item.classList.remove('open');
      qus.classList.remove('active');
      ans.style.height = 0;

      qus.onclick = function () {
        const isOpen = item.classList.contains('open');

        // if (window.innerWidth <= 749 && !isOpen) {
        if (!isOpen) {
          faqItems.forEach(i => {
            const q = i.querySelector('.faq_qus');
            const a = i.querySelector('.faq_ans');
            if (q && a) {
              i.classList.remove('open');
              q.classList.remove('active');
              a.style.height = 0;
            }
          });
        }

        if (isOpen) {
          item.classList.remove('open');
          qus.classList.remove('active');
          ans.style.height = 0;
        } else {
          item.classList.add('open');
          qus.classList.add('active');
          ans.style.height = ans.scrollHeight + 'px';
        }
      };
    });
  }

  function buildInnerFaq(reset = false) {
    const containers = document.querySelectorAll('.faq_item .faq_ans');

    containers.forEach(container => {
      if (reset) {
        container.querySelectorAll('.inner-faq-item').forEach(inner => {
          while (inner.firstChild) {
            container.insertBefore(inner.firstChild, inner);
          }
          inner.remove();
        });

        container.classList.remove('inner-faq-built');

        if (container._innerObserver) {
          container._innerObserver.disconnect();
          delete container._innerObserver;
        }
      }

      if (container.classList.contains('inner-faq-built')) return;

      const headings = Array.from(container.querySelectorAll('h3'));
      headings.forEach((heading) => {
        const innerItem = document.createElement('div');
        innerItem.className = 'inner-faq-item';

        const innerAns = document.createElement('div');
        innerAns.className = 'inner-faq-answer';

        let next = heading.nextElementSibling;
        while (next && next.tagName !== 'H3') {
          const move = next;
          next = next.nextElementSibling;
          innerAns.appendChild(move);
        }

        heading.parentNode.insertBefore(innerItem, heading);
        innerItem.appendChild(heading);
        innerItem.appendChild(innerAns);

        innerAns.style.height = 0;
        heading.style.cursor = 'pointer';

        // heading.addEventListener('click', () => {
        //   const isOpen = innerItem.classList.contains('open');

        //   container.querySelectorAll('.inner-faq-item').forEach(i => {
        //     const h = i.querySelector('h3');
        //     const a = i.querySelector('.inner-faq-answer');
        //     i.classList.remove('open');
        //     if (h) h.classList.remove('active');
        //     if (a) a.style.height = 0;
        //   });

        //   if (!isOpen) {
        //     innerItem.classList.add('open');
        //     heading.classList.add('active');
        //     innerAns.style.height = innerAns.scrollHeight + 'px';
        //   } else {
        //     innerItem.classList.remove('open');
        //     heading.classList.remove('active');
        //     innerAns.style.height = 0;
        //   }

        //   const outer = container;
        //   outer.style.height = '0px';

        //   requestAnimationFrame(() => {
        //     if (outer.closest('.open')) {
        //       const anyOpenInner = outer.querySelector('.inner-faq-item.open');
        //       if (anyOpenInner) {
        //       outer.style.height = outer.scrollHeight + 'px';
        //     } else {
              
        //       outer.style.height = outer.scrollHeight + 'px';
        //       requestAnimationFrame(() => {
        //         outer.style.height = '0px';
        //       });

              
        //       outer.addEventListener('transitionend', function handler() {
        //         if (!outer.querySelector('.inner-faq-item.open')) {
        //           outer.style.height = 'auto';
        //         }
        //         outer.removeEventListener('transitionend', handler);
        //       });
        //     }

        //     }
        //   });
        // });
        heading.addEventListener('click', () => {
              const isOpen = innerItem.classList.contains('open');


              container.querySelectorAll('.inner-faq-item').forEach(i => {
                const h = i.querySelector('h3');
                const a = i.querySelector('.inner-faq-answer');
                i.classList.remove('open');
                if (h) h.classList.remove('active');
                if (a) a.style.height = 0;
              });

              if (!isOpen) {
              
                innerItem.classList.add('open');
                heading.classList.add('active');
                innerAns.style.height = innerAns.scrollHeight + 'px';
              }

              
              const outer = container;
              requestAnimationFrame(() => {
                if (outer.closest('.open')) {
                  const openInner = outer.querySelector('.inner-faq-item.open .inner-faq-answer');
                  if (openInner) {
                    
                    outer.style.height = openInner.scrollHeight + 'px';
                  } else {
                  
                    outer.style.height = outer.scrollHeight + 'px';
                    requestAnimationFrame(() => {
                      outer.style.height = '0px';
                    });
                    outer.addEventListener('transitionend', function handler() {
                      if (!outer.querySelector('.inner-faq-item.open')) {
                        outer.style.height = 'auto';
                      }
                      outer.removeEventListener('transitionend', handler);
                    });
                  }
                }
              });
            });

      });

      const innerObserver = new ResizeObserver(() => {
        if (container.closest('.open')) {
          container.style.height = container.scrollHeight + 'px';
        }
      });

      container.querySelectorAll('.inner-faq-answer').forEach(a => innerObserver.observe(a));
      container._innerObserver = innerObserver;

      container.classList.add('inner-faq-built');
    });
  }

  function adjustOuterHeights() {
    document.querySelectorAll('.faq_item.open .faq_ans').forEach(outer => {
      requestAnimationFrame(() => {
        outer.style.height = outer.scrollHeight + 'px';
      });
    });
  }

  initFaq();
  buildInnerFaq();
  setTimeout(adjustOuterHeights, 50);

  window.addEventListener('resize', () => {
    initFaq();
    buildInnerFaq(true);
    setTimeout(adjustOuterHeights, 50);
  });
});

